"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.htmlCheck = void 0;
var htmlCheck = RegExp(/<[a-z][\s\S]*>/i);
exports.htmlCheck = htmlCheck;
var _default = htmlCheck;
exports.default = _default;